import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  discountAssignToCustomers,
  discountDelete,
  discountRedemptionsList,
  discountSave,
  discountSetEnabled,
  discountsLoad,
  discountTypesLoad,
  discountUpdate,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(discountDelete.type, send, socket);
  yield takeEvery(discountsLoad.type, send, socket);
  yield takeEvery(discountTypesLoad.type, send, socket);
  yield takeEvery(discountSave.type, send, socket);
  yield takeEvery(discountUpdate.type, send, socket);
  yield takeEvery(discountAssignToCustomers.type, send, socket);
  yield takeEvery(discountSetEnabled.type, send, socket);
  yield takeEvery(discountRedemptionsList.type, send, socket);
}
